import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-gutter" }
const _hoisted_2 = { class: "gd-documents mb-gutter" }
const _hoisted_3 = { class: "form-field form-field--gd" }
const _hoisted_4 = { class: "field-row" }
const _hoisted_5 = {
  "data-auto": "assignTo-lbl",
  class: "label label--text label--inline"
}
const _hoisted_6 = { class: "form-field form-field--gd" }
const _hoisted_7 = { class: "field-row" }
const _hoisted_8 = {
  class: "label label--text label--inline",
  "data-auto": "choosefile-lbl"
}
const _hoisted_9 = { class: "gd-file-upload" }
const _hoisted_10 = { class: "gd-file-selector" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  class: "font-small",
  "data-auto": "choosefiletext-lbl"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "gd-form-part" }
const _hoisted_15 = {
  key: 0,
  class: "success-text"
}
const _hoisted_16 = {
  key: 0,
  class: "gd-file-list font-small"
}
const _hoisted_17 = { class: "list-styled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labeltext.sarmgmtUploadDoc")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("labeltext.sarmgmtDocTitle")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attachmentModel.DocumentTitle) = $event)),
            name: "AssignTo",
            maxlength: "100"
          }, null, 512), [
            [_vModelText, _ctx.attachmentModel.DocumentTitle]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("labeltext.selectUpload")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createElementVNode("input", {
                type: "file",
                name: "choosefile",
                ref: "fileupload",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileChange($event.target.files)))
              }, null, 544),
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createTextVNode(" ("),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedFileTypes, (ext, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, [
                    _createTextVNode("." + _toDisplayString(ext), 1),
                    (index !== _ctx.allowedFileTypes.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createTextVNode(") ")
              ])
            ]),
            _createElementVNode("button", {
              class: "button button--alt",
              id: "uploadfile",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
            }, _toDisplayString(_ctx.$t("labeltext.upload")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h3", null, [
          (_ctx.showFileUploadSuccessMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("labeltext.fileUploadSuccessful")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.DocumentList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("labeltext.listUploadedFiles")), 1),
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DocumentList, (item, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(index + 1) + ". " + _toDisplayString(item.fileName), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}